import './styles/reset.s';
import './styles/global.s';
import './styles/fonts.s';
import * as React from 'react';
import { Core } from '@core';
import { App } from '@components/App/App';

const app = new Core();

app.boot(
  <App />,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// src/app/src/index.tsx